// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"ac895815","821":"b9c24a21"}[chunkId] + ".chunk.js";
};